"use strict";

window.editTask = function(id, theTypeId, theTypeName, theDataType) {
    window.Livewire.dispatch("loadTaskInfo", { taskId: id });
    window.setAssetType(theTypeId, theTypeName, theDataType);
    window.setTaskModalTitle('Edit Task');
    window.showTaskModal();
    setTimeout(function() { KTMenu.createInstances(); }, 250);
}

window.addNewTask = function() {
    window.Livewire.dispatch("resetAddTaskForm");
    window.setTaskModalTitle('Add New Task');
    window.showTaskModal();
    setTimeout(function() { KTMenu.createInstances(); }, 250);
}

window.openTaskModalForAsset = function (assetId, assetName, dataType, taskType, modalTitle, section, assignCurrentUser) {
    var payload = {
        assetType: assetId,
        assetTypeName: assetName,
        dataType: dataType,
        taskType: taskType,
    };
    if (typeof section === "string" && section.length) {
        payload.section = section;
    }
    if (assignCurrentUser) {
        payload.assignCurrentUser = true;
    }
    window.Livewire.dispatch("openTaskModalForAsset", payload);
    window.setTaskModalTitle(modalTitle);
    window.showTaskModal();
    setTimeout(function() { KTMenu.createInstances(); }, 250);
};

window.addNewTaskToDealById = function(e, id, name) {
    e.preventDefault();
    window.openTaskModalForAsset(id, name, "deal", "task", "Add New Task");
}

window.addNewTaskToContactById = function(e, id, name) {
    e.preventDefault();
    window.openTaskModalForAsset(id, name, "contact", "task", "Add New Task");
}

window.addNewTaskToCompanyById = function(e, id, name) {
    e.preventDefault();
    window.openTaskModalForAsset(id, name, "company", "task", "Add New Task");
}

window.addNewTaskDeal = function(section) {
    window.openTaskModalForAsset(window.deal_id, document.title, "deal", "task", "Add New Task", section);
}

window.addNewMilestoneDeal = function() {
    window.openTaskModalForAsset(window.deal_id, document.title, "deal", "milestone", "Add New Milestone");
}

window.addNewTaskContact = function() {
    window.openTaskModalForAsset(window.currentContactID, jQuery("#divCurrentContactName").html(), "contact", "task", "Add New Task", null, true);
}

window.addNewMilestoneContact = function() {
    window.openTaskModalForAsset(window.currentContactID, jQuery("#divCurrentContactName").html(), "contact", "milestone", "Add New Milestone");
}

window.addNewTaskCompany = function() {
    window.openTaskModalForAsset(window.currentCompanyID, jQuery("#divCurrentCompanyName").html(), "company", "task", "Add New Task", null, true);
}

window.addNewMilestoneCompany = function() {
    window.openTaskModalForAsset(window.currentCompanyID, jQuery("#divCurrentCompanyName").html(), "company", "milestone", "Add New Milestone");
}

window.setTaskModalTitle = function(title) {
    jQuery("#kt_modal_new_task_title").html(title);
}

window.showTaskModal = function() {
    jQuery("#kt_modal_new_task").modal("show");
}

window.setTaskModalDatepickerState = function (isCalendarOpen) {
    const taskModal = document.querySelector("#kt_modal_new_task");

    if (! taskModal || typeof bootstrap === "undefined" || ! bootstrap.Modal) {
        return;
    }

    const modalInstance = bootstrap.Modal.getInstance(taskModal);

    if (! modalInstance) {
        return;
    }

    modalInstance._config.backdrop = isCalendarOpen ? "static" : true;
    modalInstance._config.keyboard = ! isCalendarOpen;
};

window.initializeNewTask = function () {
    const dueDateInput = document.querySelector("#new_task_due_date");
    const taskModalContent = document.querySelector("#kt_modal_new_task");
    const contactDrawer = document.querySelector("#kt_drawer_view_contact");
    const isContactDrawerOpen = contactDrawer && contactDrawer.classList.contains("drawer-on");

    if (! dueDateInput) {
        return;
    }

    const flatpickrOptions = {
        enableTime: false,
        altFormat: "m/d/Y",
        dateFormat: "Y-m-d",
        positionElement: dueDateInput,
        onOpen: function () {
            window.setTaskModalDatepickerState(true);
        },
        onClose: function () {
            window.setTaskModalDatepickerState(false);
        },
    };

    if (isContactDrawerOpen) {
        flatpickrOptions.appendTo = taskModalContent || document.body;
    } else {
        flatpickrOptions.appendTo = document.body;
    }

    if (dueDateInput._flatpickr){
        window.setTaskModalDatepickerState(false);
        dueDateInput._flatpickr.destroy();
    }

    jQuery("#new_task_due_date").flatpickr(flatpickrOptions);
};

window.setAssetType = function (id, name, dataType) {
    window.Livewire.dispatch("setAssetType", { assetType: id, assetTypeName: name, dataType: dataType });
};

jQuery(document).on("shown.bs.modal", "#kt_modal_new_task", function () {
    window.initializeNewTask();
    window.elevateTaskModalAboveClosingBlocker();
});

jQuery(document).on("hidden.bs.modal", "#kt_modal_new_task", function () {
    window.clearTaskModalClosingBlockerElevation();
});

window.elevateTaskModalAboveClosingBlocker = function () {
    if (! document.querySelector(".app-closing-dependent-blocker")) {
        return;
    }

    var taskModal = document.querySelector("#kt_modal_new_task");
    if (taskModal) {
        taskModal.style.zIndex = "1070";
    }

    var backdrops = document.querySelectorAll(".modal-backdrop");
    if (backdrops.length) {
        backdrops[backdrops.length - 1].style.zIndex = "1068";
    }
};

window.clearTaskModalClosingBlockerElevation = function () {
    var taskModal = document.querySelector("#kt_modal_new_task");
    if (taskModal) {
        taskModal.style.zIndex = "";
    }

    document.querySelectorAll(".modal-backdrop").forEach(function (backdrop) {
        if (backdrop.style.zIndex === "1068") {
            backdrop.style.zIndex = "";
        }
    });
};

document.addEventListener("livewire:init", function () {
    // Livewire.on("initNewTask", () => {
    //     window.initializeNewTask();
    // });

    function reloadOpenProfileDrawerAfterTaskChange() {
        var contactDrawerOpen = document.querySelector("#kt_drawer_view_contact.drawer-on");
        var companyDrawerOpen = document.querySelector("#kt_drawer_view_company.drawer-on");

        if (contactDrawerOpen && window.currentContactID && typeof window.viewContact === "function") {
            window.scrollToTop = false;
            window.viewContact(new Event("click"), window.currentContactID);
            return;
        }

        if (companyDrawerOpen && window.currentCompanyID && typeof window.viewCompany === "function") {
            window.viewCompany(new Event("click"), window.currentCompanyID);
        }
    }

    Livewire.on("newTaskCreated", () => {
        jQuery("#kt_modal_new_task").modal("hide");
        window.toastSuccess("Task created!");
        reloadOpenProfileDrawerAfterTaskChange();
    });

    Livewire.on("taskUpdated", () => {
        jQuery("#kt_modal_new_task").modal("hide");
        window.toastSuccess("Task updated!");
        reloadOpenProfileDrawerAfterTaskChange();
    });

    Livewire.on("refreshPipelineDatatable", () => {
        if (typeof window.statusDataTables !== "undefined") {
            for (const key in window.statusDataTables) {
                if (window.statusDataTables.hasOwnProperty(key)) {
                    window.statusDataTables[key].ajax.reload();
                }
            }
        }
        if (typeof window.dashboardDataTables !== "undefined") {
            for (const key in window.dashboardDataTables) {
                if (window.dashboardDataTables.hasOwnProperty(key)) {
                    window.dashboardDataTables[key].ajax.reload();
                }
            }
        }

        if (typeof window.dataTablePropertyMap !== "undefined") {
            window.dataTablePropertyMap.ajax.reload();
        }
    });

    Livewire.on("refreshCompaniesDatatable", () => {
        if (typeof window.companiesDataTable !== "undefined") {
            window.companiesDataTable.ajax.reload();
        }
    });

    Livewire.on("refreshContactsDatatable", () => {
        if (typeof window.contactsDataTable !== "undefined") {
            window.contactsDataTable.ajax.reload();
        }
    });
});
